import axios, { CancelToken, CancelTokenSource } from "axios";
import { AxiosRequestConfig } from 'axios';

const currentExecutingCancellableRequests: { [key: string]: CancelTokenSource } = {};

export const handleCancellableResponse = (token: CancelToken | undefined): void => {
	if (!token) {
		return;
	}
	const key = Object.keys(currentExecutingCancellableRequests).find((key) => currentExecutingCancellableRequests[key].token === token);
	if (key) {
		delete currentExecutingCancellableRequests[key];
	}
};

export const handleCancellableRequest = (request: AxiosRequestConfig): void => {
	const cancelUniqId = (request.cancelToken as unknown) as string;

	if (currentExecutingCancellableRequests[cancelUniqId]) {
		const source = currentExecutingCancellableRequests[cancelUniqId];
		delete currentExecutingCancellableRequests[cancelUniqId];
		source.cancel("canceled");
	}

	if (cancelUniqId) {
		const CancelToken = axios.CancelToken;
		const source = CancelToken.source();
		request.cancelToken = source.token;
		currentExecutingCancellableRequests[cancelUniqId] = source;
	}
};
